import { render, staticRenderFns } from "./InvoiceAttachments.vue?vue&type=template&id=cc10f41e&scoped=true"
import script from "./InvoiceAttachments.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoiceAttachments.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoiceAttachments.vue?vue&type=style&index=0&id=cc10f41e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc10f41e",
  null
  
)

export default component.exports